exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-screen-btn-con .ivu-tooltip-rel {\n  height: 64px;\n  line-height: 56px;\n}\n.full-screen-btn-con .ivu-tooltip-rel i {\n  cursor: pointer;\n}\n", ""]);

// exports
